import React from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Form from 'form/Form';

const ConfirmCreditInvoiceDialog = ({ purchase, open, onSubmit, onCancel }) => {
    const handleFormSubmit = () => {
        onSubmit();
    };

    return (
        <Dialog maxWidth="md" open={open} onClose={onCancel}>
            <Form
                onSubmit={handleFormSubmit}
            >
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <DialogTitle disableTypography>
                            <Typography variant="h5">
                                Credit invoice
                            </Typography>
                        </DialogTitle>
                        <DialogContent>
                            <Typography variant="body1">
                                Confirm crediting the invoice for the purchase with ID {purchase.id}.
                            </Typography>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                            >
                                Confirm
                            </Button>
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={onCancel}
                            >
                                Cancel
                            </Button>
                        </DialogActions>
                    </form>
                )}
            </Form>
        </Dialog>
    );
};

ConfirmCreditInvoiceDialog.propTypes = {
    purchase: PropTypes.object.isRequired,
    open: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired
};

export default ConfirmCreditInvoiceDialog;
